import React, { useState, useEffect, useRef, useMemo } from 'react';
import './inputDate.scss';
import CalendarSVG from '../icons/calendar';
import Tooltip from '../Tooltip/Tooltip';
import { getWeekDateRange } from '../../utils/dateUtils';


//Funcion para determinar rango de fechas en una semana
// function getWeekDateRange(weekNumber, year) {
//     // Obtener el 4 de enero del año dado (para cumplir con la norma ISO 8601)
//     const fourthOfJanuary = new Date(year, 0, 4);

//     // Calcular el lunes de la primera semana ISO 8601 (restando los días necesarios para llegar al lunes)
//     const firstMonday = new Date(fourthOfJanuary);
//     firstMonday.setDate(fourthOfJanuary.getDate() - (fourthOfJanuary.getDay() + 6) % 7);
//     // console.log(firstMonday)
//     // Calcular el inicio de la semana deseada sumando (weekNumber - 1) * 7 días
//     const startOfWeek = new Date(firstMonday);
//     startOfWeek.setDate(firstMonday.getDate() + (weekNumber - 1) * 7);

//     // Calcular el final de la semana (sumando 6 días al inicio)
//     const endOfWeek = new Date(startOfWeek);
//     endOfWeek.setDate(startOfWeek.getDate() + 6);

//     return { start: startOfWeek, end: endOfWeek };
// };

//
const InputDate = ({ selectionType, valueType, onChange, minDate, placeholder, onClose, resetKey, specialDates }) => {
    // States
    const [selectedDate, setSelectedDate] = useState(null);
    const [showCalendar, setShowCalendar] = useState(false);
    const [selectedRange, setSelectedRange] = useState({ start: null, end: null });
    const [selectedWeek, setSelectedWeek] = useState(null);
    const [dateRangeSelected, setDateRangeSelected] = useState("");
    const [showMonthPicker, setShowMonthPicker] = useState(false); // Estado para mostrar el selector de meses
    const [showYearPicker, setShowYearPicker] = useState(false); // Estado para mostrar el selector de años
    const datepickerRef = useRef(null);

    const weekRangeArray = [];
    // Convertir minDate a objeto Date (si no es nulo)
    const minDateObj = minDate ? new Date(minDate) : null;
    //fechas especiales recibidas
    const { vacations, exemptWeeks, holidays } = useMemo(() => {
        const data = specialDates || {};

        const mapWeeks = (arr = []) =>
            arr.map(({ week, year }) => getWeekDateRange(week, year));

        return {
            vacations: mapWeeks(data.vacations),
            exemptWeeks: mapWeeks(data.exemptWeeks),
            holidays: (data.holidays || []).map(({ date }) => new Date(date))
        };
    }, [specialDates]);

    const isInRange = (date, ranges = []) => {
        return ranges.some(({ start, end }) =>
            date >= start && date <= end
        );
    };

    const isSameDay = (date, dates = []) => {
        return dates.some(d =>
            d.getFullYear() === date.getFullYear() &&
            d.getMonth() === date.getMonth() &&
            d.getDate() === date.getDate()
        );
    };

    // UseEffect to restore the current date and handle outside click
    useEffect(() => {
        const onClickOutside = (e) => {
            if (
                datepickerRef.current &&
                !datepickerRef.current.contains(e.target) &&
                (showCalendar || showMonthPicker || showYearPicker)
            ) {
                setShowCalendar(false);
                setShowMonthPicker(false);
                setShowYearPicker(false);
                if (onClose) onClose();
            }
        };
        setCurrentDate(); // aquí si quieres, o fuera del useEffect
        document.addEventListener('click', onClickOutside);
        return () => {
            document.removeEventListener('click', onClickOutside);
        };
    }, [dateRangeSelected, selectedRange, showCalendar, showMonthPicker, showYearPicker]);

    useEffect(() => {
        setSelectedDate(null);
        setSelectedRange({ start: null, end: null });
        setSelectedWeek(null);
        setDateRangeSelected("");
    }, [resetKey]);
    // Function to restore the current date
    const setCurrentDate = () => {
        const currentDate = new Date();
    };

    // Function to render the dropdown calendar
    const renderCalendar = () => {
        const currentDate = selectedDate || new Date();
        const year = currentDate.getFullYear();
        const month = currentDate.getMonth();
        const firstDayOfMonth = new Date(year, month, 1);
        const lastDayOfMonth = new Date(year, month + 1, 0);
        const today = new Date();

        const daysInMonth = lastDayOfMonth.getDate();
        const startDayOfWeek = firstDayOfMonth.getDay();

        // Ajustar el día de inicio para que la semana comience en Lunes (1)
        const startOffset = startDayOfWeek === 0 ? 6 : startDayOfWeek - 1;

        // Calcular el primer día a mostrar en el calendario (puede ser del mes anterior)
        const firstDayToShow = new Date(firstDayOfMonth);
        firstDayToShow.setDate(firstDayToShow.getDate() - startOffset);

        let dayCounter = 0; // Comenzar desde el primer día de la semana
        const rows = [];

        for (let i = 0; i < 6; i++) {
            const cells = [];
            let hasDaysInCurrentMonth = false; // Bandera para verificar si hay días del mes actual en la semana

            for (let j = 0; j < 7; j++) {
                const currentDay = new Date(firstDayToShow);
                currentDay.setDate(firstDayToShow.getDate() + dayCounter);

                const dayValue = currentDay.getDate();
                const isCurrentMonth = currentDay.getMonth() === month;

                // Verificar si el día está dentro del rango seleccionado
                const isSelectedRange = selectedRange.start && selectedRange.end &&
                    currentDay >= selectedRange.start && currentDay <= selectedRange.end;

                // Verificar si el día es el inicio del rango seleccionado
                const isStartOfRange = selectedRange.start && currentDay.getTime() === selectedRange.start.getTime();

                // Verificar si el día es el final del rango seleccionado
                const isEndOfRange = selectedRange.end && currentDay.getTime() === selectedRange.end.getTime();

                // Verificar si el día está dentro de la semana seleccionada
                const isSelectedWeek = selectedWeek && currentDay >= selectedWeek.start && currentDay <= selectedWeek.end;

                // Verificar si es hoy
                const isToday = today.getFullYear() === currentDay.getFullYear() &&
                    today.getMonth() === currentDay.getMonth() &&
                    today.getDate() === currentDay.getDate();
                //Verificar si es semana vacacional
                const isVacation = isInRange(currentDay, vacations);

                //Verificar si es semana exenta de pago
                const isExemptWeek = isInRange(currentDay, exemptWeeks);

                //Verificar si es dia festivo
                const isHoliday = isSameDay(currentDay, holidays);


                // Si el día pertenece al mes actual, marcamos la bandera como verdadera
                if (isCurrentMonth) {
                    hasDaysInCurrentMonth = true;
                }

                cells.push(
                    <td
                        key={j}
                        onClick={() => selectDate(currentDay)} // Permitir selección de cualquier día renderizado
                        //AQUI SE DETERMINA EL ESTILO DE LA CELDA SE LE ASIGNA UNA CLASE CSS
                        className={[
                            `${selectionType} day`,
                            !isCurrentMonth && 'other-month',
                            selectionType === 'date' && selectedDate && currentDay.getTime() === selectedDate.getTime() && (isToday ? 'todays-date selected' : 'selected'),
                            isSelectedRange && (isToday ? 'todays-date selected-range' : 'selected-range'),
                            currentDay < minDateObj && 'disabled',
                            isSelectedWeek && 'selected-week',
                            isToday && 'todays-date',
                            isStartOfRange && 'selected-start',
                            isEndOfRange && 'selected-end',
                            isVacation && 'vacation',
                            isExemptWeek && 'exempt-week',
                            isHoliday && 'holiday',
                        ].filter(Boolean).join(' ')}

                    // className={`
                    //     ${selectionType} day
                    //     ${!isCurrentMonth ? 'other-month' : null}
                    //     ${selectionType === 'date' && selectedDate && currentDay.getTime() === selectedDate.getTime() ? (isToday ? 'todays-date selected' : 'selected') : null}
                    //     ${isSelectedRange ? (isToday ? 'todays-date selected-range' : 'selected-range') : null}
                    //     ${currentDay < minDateObj ? 'disabled' : null}
                    //     ${isSelectedWeek ? 'selected-week' : null}
                    //     ${isToday ? 'todays-date' : null}
                    //     ${isStartOfRange ? 'selected-start' : null}
                    //     ${isEndOfRange ? 'selected-end' : null}
                    //     ${isVacation ? 'vacation' : null}
                    //     ${isExemptWeek ? 'exempt-week' : null}
                    //     ${isHoliday ? 'holiday' : null}
                    // `}
                    >
                        {isExemptWeek?<Tooltip text={'Semana excenta de pago'} position='left' ><p>{dayValue}</p></Tooltip>:
                        isVacation ? <Tooltip text={'Vacaciones'} position='left' ><p>{dayValue}</p></Tooltip>:
                        !isVacation & !isExemptWeek &&<p>{dayValue}</p>}
                    </td>
                );

                dayCounter++;
            }

            // Solo agregamos la semana si hay días del mes actual en ella
            if (hasDaysInCurrentMonth || i < 5) {
                rows.push(<tr key={i}>{cells}</tr>);
            }
        }

        return rows;
    };

    // Function to toggle the calendar visibility
    const toggleCalendar = () => {
        setShowCalendar(!showCalendar);
        setShowMonthPicker(false);
        setShowYearPicker(false);
    };

    // Function to select a date or range depending on the selection type
    const selectDate = (date) => {
        const year = date.getFullYear();
        const month = date.getMonth();
        const day = date.getDate();
        let start, end;
        let dateRangeG = '';
        let isExempt= isInRange(date, exemptWeeks);
        if (minDateObj && date < minDateObj||isExempt) return; // No permitir fechas menores a minDate

        if (selectionType === 'date') {
            // Handle date selection
            setSelectedDate(new Date(year, month, day));
            setShowCalendar(false); // Cerrar el calendario solo al seleccionar una fecha
        } else if (selectionType === 'range' || selectionType === 'week-range') {
            if (selectedRange.end !== null) {
                // If an end date is already selected, reset the range
                setSelectedRange({ start: null, end: null });
                setDateRangeSelected('');
                setSelectedDate(new Date(year, month, day));
            } else if (!selectedRange.start) {
                // If no start date is selected, set the start date
                start = new Date(year, month, day);
                if (selectionType === 'week-range') {
                    const dayOfWeek = start.getDay();
                    // Adjust start to the Monday of the selected week
                    start.setDate(start.getDate() - (dayOfWeek === 0 ? 6 : dayOfWeek - 1));
                }
                setSelectedRange({ start, end: null });
            } else {
                // If start date is selected but no end date, set the end date and finalize the range
                start = selectedRange.start;
                end = new Date(year, month, day);

                // **Correction: swap if end is earlier than start**
                if (end < start) {
                    let newStart = end;
                    end = start;
                    start = newStart;
                }

                if (selectionType === 'week-range') {
                    const dayOfWeek = end.getDay();
                    const dayOfWeek2 = start.getDay();
                    // Adjust end to the Sunday of the selected week
                    end.setDate(end.getDate() + (dayOfWeek === 0 ? dayOfWeek : 7 - dayOfWeek));
                    start.setDate(start.getDate() - (dayOfWeek2 === 0 ? 6 : dayOfWeek2 - 1));
                }

                setSelectedRange({ start, end });
                rangeWeekNumbers(start, end, month, year);
                setDateRangeSelected(`${formatDate(start)} - ${formatDate(end)}`);
                dateRangeG = `${formatDate(start)} - ${formatDate(end)}`
            }
        } else if (selectionType === 'week') {
            // If 'week' selection is chosen, adjust to the week range
            start = new Date(year, month, day);
            const dayOfWeek = start.getDay();
            // Adjust start to Monday of the selected week
            start.setDate(start.getDate() - (dayOfWeek === 0 ? 6 : dayOfWeek - 1));
            end = new Date(start);
            // Set end to Sunday of the selected week
            end.setDate(end.getDate() + 6);

            setSelectedWeek({ start, end });
            const newRangeSelected = `${formatDate3(start)} - ${formatDate3(end)}`;
            setDateRangeSelected(newRangeSelected);
            dateRangeG = newRangeSelected
            rangeWeekNumbers(start, end, month, year);
            setShowCalendar(false); // Cerrar el calendario solo al seleccionar una semana
        }
        if (selectionType === 'date') {
            onChange && onChange(new Date(year, month, day));
        } else if (valueType === 'weekNumber') {
            onChange && onChange(weekRangeArray);
        } else {
            onChange && onChange(dateRangeG);

        }
    };

    const rangeWeekNumbers = (start, end) => {
        let endMonth = end.getMonth();
        let endYear = end.getFullYear();
        let startWeek = getWeekNumber(start);
        let endWeek = getWeekNumber(new Date(endYear, endMonth, end.getDate() - 1));
        let startYear = startWeek.year;
        let daysBetween = (end - start) / (1000 * 60 * 60 * 24);

        // Reiniciar el array para evitar acumulaciones previas
        weekRangeArray.length = 0;

        let i = startWeek.weekNumber;
        let year = startYear;

        while (true) {
            weekRangeArray.push({ week: i, year });

            // Si hemos alcanzado la semana final, salimos del bucle
            if (i === endWeek.weekNumber && year === endYear) {
                break;
            }

            // Incrementamos la semana
            i++;

            // Si pasamos la semana 52, cambiamos de año
            if (i > 52) {
                i = 1;
                year++;
            }
        }

    };



    // Function to move to the previous month
    const prevMonth = () => {
        const year = selectedDate ? selectedDate.getFullYear() : new Date().getFullYear();
        const month = selectedDate ? selectedDate.getMonth() : new Date().getMonth();
        setSelectedDate(new Date(year, month - 1, 1));
    };

    // Function to move to the next month
    const nextMonth = () => {
        const year = selectedDate ? selectedDate.getFullYear() : new Date().getFullYear();
        const month = selectedDate ? selectedDate.getMonth() : new Date().getMonth();
        setSelectedDate(new Date(year, month + 1, 1));
    };

    // Function to get the month name
    const getMonthName = (month) => {
        const months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
        return months[month];
    };

    // Function to get the year
    const getYear = (date) => {
        let year = new Date(date).getFullYear();
        return year;
    };

    // Functions for date formats
    const formatDate = (date) => {
        const options = { year: 'numeric', month: 'numeric', day: '2-digit' };
        return date.toLocaleDateString('es-ES', options);
    };

    const formatDate2 = (date) => {
        const options = { year: 'numeric', month: 'long', day: '2-digit' };
        return date.toLocaleDateString('es-ES', options);
    };

    const formatDate3 = (date) => {
        const options = { year: 'numeric', month: 'short', day: '2-digit' };
        return date.toLocaleDateString('es-ES', options);
    };

    // Function to handle the selected date display
    const handleDateSelected = () => {
        if (selectionType === 'date' && selectedDate) {
            return formatDate3(selectedDate); // Formato para una fecha seleccionada
        } else {
            return dateRangeSelected;
        }
    };

    //Function to get de week number of a date
    function getWeekNumber(date) {
        const tempDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
        // Ajustar para que la semana inicie en lunes
        tempDate.setUTCDate(tempDate.getUTCDate() + 4 - (tempDate.getUTCDay() || 7));
        // Calcular el inicio del año
        const yearStart = new Date(Date.UTC(tempDate.getUTCFullYear(), 0, 1));
        // Calcular la diferencia en días y obtener la semana
        const weekNumber = Math.ceil(((tempDate - yearStart) / 86400000 + 1) / 7);

        return { weekNumber, year: tempDate.getUTCFullYear() };
    }

    // Function to render the month picker
    const renderMonthPicker = () => {
        const months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
        return (
            <div className="month-picker main-color">
                {months.map((month, index) => (
                    <div
                        key={index}
                        className="month-item"
                        onClick={() => {
                            const year = selectedDate ? selectedDate.getFullYear() : new Date().getFullYear();
                            setSelectedDate(new Date(year, index, 1));
                            setShowMonthPicker(false); // Solo cerrar el selector de meses
                        }}
                    >
                        {month}
                    </div>
                ))}
            </div>
        );
    };

    // Function to render the year picker
    const renderYearPicker = () => {
        const currentYear = new Date().getFullYear();
        const years = Array.from({ length: 12 }, (_, i) => currentYear - 6 + i); // Mostrar 12 años (6 anteriores y 6 posteriores)
        return (
            <div className="year-picker main-color">
                {years.map((year) => (
                    <div
                        key={year}
                        className="year-item"
                        onClick={() => {
                            const month = selectedDate ? selectedDate.getMonth() : new Date().getMonth();
                            setSelectedDate(new Date(year, month, 1));
                            setShowYearPicker(false); // Solo cerrar el selector de años
                        }}
                    >
                        {year}
                    </div>
                ))}
            </div>
        );
    };

    return (
        <div className="custom-datepicker main-color" ref={datepickerRef}>
            <CalendarSVG></CalendarSVG>
            <input
                className="input-date main-color"
                type="text"
                readOnly
                onClick={toggleCalendar}
                value={handleDateSelected()}
            />
            <label className='label-placeholder'>
                {placeholder}
            </label>
            {showCalendar && (
                <div className="calendar-container main-color" style={{ display: showCalendar ? 'block' : 'none' }}>
                    <div className="calendar-header">
                        <span className='year' onClick={() => setShowYearPicker(!showYearPicker)}>
                            {getYear(selectedDate || new Date())}
                        </span>
                        <div>
                            <span className="prev-month" onClick={prevMonth}>&#60;</span>
                            <span className="current-month" onClick={() => setShowMonthPicker(!showMonthPicker)}>
                                {getMonthName(selectedDate ? selectedDate.getMonth() : new Date().getMonth())}
                            </span>
                            <span className="next-month" onClick={nextMonth}>&#62;</span>
                        </div>
                    </div>
                    {showMonthPicker && renderMonthPicker()}
                    {showYearPicker && renderYearPicker()}
                    <table>
                        <thead>
                            <tr>
                                <th>L</th>
                                <th>M</th>
                                <th>M</th>
                                <th>J</th>
                                <th>V</th>
                                <th>S</th>
                                <th>D</th>
                            </tr>
                        </thead>
                        <tbody>{renderCalendar()}</tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default InputDate;